var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalAlt5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V6.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75H22V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V7.75ZM12.7 10H11.3C11.0239 10 10.8 10.2239 10.8 10.5V12.8H8.5C8.22386 12.8 8 13.0239 8 13.3V14.7C8 14.9761 8.22386 15.2 8.5 15.2H10.8V17.5C10.8 17.7761 11.0239 18 11.3 18H12.7C12.9761 18 13.2 17.7761 13.2 17.5V15.2H15.5C15.7761 15.2 16 14.9761 16 14.7V13.3C16 13.0239 15.7761 12.8 15.5 12.8H13.2V10.5C13.2 10.2239 12.9761 10 12.7 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalAlt5);
export default __webpack_public_path__ + "static/media/hospital-alt-5.30a9aadd6b2ffda40da935cdd69dadfb.svg";
export { ForwardRef as ReactComponent };